export const headerFix: Function = () => {
    const headerElHeight: Number = document.querySelector('.Header').getBoundingClientRect().height;
    let scrollTop: Number;

    const scrollEventHandler: Function = () => {
        if (scrollTop >= headerElHeight) {
            document.body.classList.add('ScrolledBelowHeader');
        } else {
            document.body.classList.remove('ScrolledBelowHeader');
        }
    }

    document.addEventListener('scroll', () => {
        scrollTop = window.pageYOffset;
        scrollEventHandler()
    });

    document.addEventListener('touchmove', () => {
        scrollTop = window.pageYOffset;
        scrollEventHandler()
    });
}
